// App.js
import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import Navbar from "./components/Navbar";

import MasterSiteManager from "./components/MasterSiteManager";
import SiteManager from "./components/SiteManager";
import TodayReportViewer from "./components/TodayReportViewer";
import DailyReportViewer from "./components/DailyReportViewer";
import UserManager from "./components/UserManager";
import SiteViewer from "./components/SiteViewer";
import ReportTrigger from "./components/ReportTrigger";
import RegularSMSViewer from "./components/RegularSMSViewer";
import PartManager from "./components/PartManager";
import LoginPage from "./components/LoginPage";
import CronStatus from "./components/CronStatus";
import CompareSitesViewer from "./components/CompareSitesViewer";
import GraphEachDay from "./components/GraphEachDay";
import TechnicianMaintenancePage from "./components/TechnicianMaintenancePage";
import RoleManager from "./components/RoleManager";
import ProfilePage from "./components/ProfilePage";
import WorksManager from "./components/WorksManager";
import FinanceDashboard from "./components/FinanceCashbook";
import PaymentTasksPage from "./components/PaymentTasksPage";
import DailyTaskPage from "./components/DailyTaskPage";
import AmcTasksPage from "./components/AmcTasksPage";
import UploadsManager from "./components/UploadsManager";

function Logout() {
  console.log("Logout route hit", window.location.pathname);
  alert("You have been logged out.", window.location.pathname);
  const { logout } = useContext(AuthContext);

  useEffect(() => {
    logout();
  }, [logout]);
  return null;
}

function AppContent() {
  const { user } = useContext(AuthContext);

  return (
    <div className="app-shell">
      {/* Navbar only when logged in */}
     

      {/* ✅ Full-width page content */}
      <main className="main-content">
        {user && <Navbar />}
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/logout" element={<Logout />} />

          <Route
            path="/master-site-manager"
            element={
              <PrivateRoute>
                <MasterSiteManager />
              </PrivateRoute>
            }
          />
          <Route path="/amc" element={<PrivateRoute><AmcTasksPage /></PrivateRoute>} />
          <Route
            path="/masterandsite"
            element={
              <PrivateRoute>
                <SiteManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/today-report-viewer/"
            element={
              <PrivateRoute>
                <TodayReportViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/daily-report-viewer/"
            element={
              <PrivateRoute>
                <DailyReportViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/user-manager"
            element={
              <PrivateRoute>
                <UserManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/site-manager"
            element={
              <PrivateRoute>
                <SiteViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/trigger-reports"
            element={
              <PrivateRoute>
                <ReportTrigger />
              </PrivateRoute>
            }
          />
          <Route
            path="/regular-sms-viewer"
            element={
              <PrivateRoute>
                <RegularSMSViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/cron-status"
            element={
              <PrivateRoute>
                <CronStatus />
              </PrivateRoute>
            }
          />
          <Route
            path="/compare-sites-viewer"
            element={
              <PrivateRoute>
                <CompareSitesViewer />
              </PrivateRoute>
            }
          />
          <Route
            path="/graph-each-day"
            element={
              <PrivateRoute>
                <GraphEachDay />
              </PrivateRoute>
            }
          />
          <Route
            path="/technician"
            element={
              <PrivateRoute>
                <TechnicianMaintenancePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/role"
            element={
              <PrivateRoute>
                <RoleManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/parts"
            element={
              <PrivateRoute>
                <PartManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/works"
            element={
              <PrivateRoute>
                <WorksManager />
              </PrivateRoute>
            }
          />
          <Route
            path="/finance"
            element={
              <PrivateRoute>
                <FinanceDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/payment"
            element={
              <PrivateRoute>
                <PaymentTasksPage />
              </PrivateRoute>
            }
          />
          <Route path="/daily-tasks" element={<PrivateRoute><DailyTaskPage /></PrivateRoute>} />
          <Route
            path="/uploads-manager"
            element={
              <PrivateRoute>
                <UploadsManager />
              </PrivateRoute>
            }
          />

          <Route
            path="*"
            element={
              <PrivateRoute>
                <h1>404 Not Found</h1>
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;